type ExclusivePdpTitleVariant =
	| "mobile"
	| "mobileWithCount"
	| "singular"
	| "plural"
	| "pluralWithCount";

export type ExclusivePdpTitleTranslationKey =
	| "curated.exclusive.pdp.title.mobile"
	| "curated.exclusive.pdp.title.mobileWithCount"
	| "curated.exclusive.pdp.title.singular"
	| "curated.exclusive.pdp.title.plural"
	| "curated.exclusive.pdp.title.pluralWithCount";

export function getExclusivePdpTitleKey(
	count: number,
	isMobile: boolean,
): ExclusivePdpTitleVariant {
	if (isMobile) {
		if (count >= 3) {
			return "mobileWithCount";
		}
		return "mobile";
	}
	if (count === 1) {
		return "singular";
	}
	if (count >= 3) {
		return "pluralWithCount";
	}
	return "plural";
}

export function getExclusivePdpTitleTranslationKey(
	count: number,
	isMobile: boolean,
): ExclusivePdpTitleTranslationKey {
	const variant = getExclusivePdpTitleKey(count, isMobile);
	return `curated.exclusive.pdp.title.${variant}`;
}

export function getExclusivePdpTitleInterpolationOptions(
	count: number,
	isMobile: boolean,
): { count: number } | undefined {
	const variant = getExclusivePdpTitleKey(count, isMobile);
	if (variant === "mobileWithCount" || variant === "pluralWithCount") {
		return { count };
	}
	return undefined;
}
